// client/src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import LiveKitSessionPage from './livekit/LiveKitSessionPage';
import RoomRedirect from './livekit/RoomRedirect';
import LiveKitRoomDirect from './livekit/LiveKitRoomDirect';
import LiveKitRecordingTemplatePage from './livekit/recordingTemplate/LiveKitRecordingTemplatePage';
import GlobalErrorBoundary from './GlobalErrorBoundary';
import { installClientLogBridge } from './livekit/clientLogReporter';
import { installCorrelationBootstrap } from './livekit/correlation';
import { installMintAuthListener } from './livekit/mintAuth';
// TI-413: shared design tokens (auto-synced copy; source of truth = interviews-ui/src/tokens/tokens.css)
import './styles/tokens.css';
import './styles/App.css';
import './styles/Room.css';

installClientLogBridge();
// TI-316: seed sessionId from the join URL and accept it from the embedding
// parent (interviews-ui) via a validated postMessage; powers X-Session-Id.
installCorrelationBootstrap();
// TI-974: accept a UM access token from the embedding parent (ti:auth) so the
// VSS token mint can carry credentials. Fail-open when none arrives.
installMintAuthListener();

ReactDOM.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          {/* TI-976: keep the query string (roomid/name/sessionId/inviteToken) across the redirect */}
          <Route path="/room" element={<RoomRedirect />} />
          <Route path="/livekit" element={<LiveKitSessionPage />} />
          <Route path="/livekit/room" element={<LiveKitRoomDirect />} />
          <Route path="/livekit/record-template" element={<LiveKitRecordingTemplatePage />} />
        </Routes>
      </BrowserRouter>
    </GlobalErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);